import { useEffect } from 'react';
import { SHORTBREAD_CONTAINER_ID } from '../constants/cookies';

import { useLocaleContext } from '../contexts/LocaleContextProvider';
import { createShortbreadInstance, getShortbread } from '../services/cookies';

const CookieConsent = () => {
  const { locale } = useLocaleContext();
  useEffect(() => {
    // Initialize shortbread on load and reinitialize whenever the locale changes.
    createShortbreadInstance(locale);
    const shortbread = getShortbread();
    shortbread.checkForCookieConsent();
  }, [locale]);

  return <div id={SHORTBREAD_CONTAINER_ID} />;
};

export default CookieConsent;
